import OctalComponentPage from '../../components/octal-component-page'

export default function Traefik() {
    return (
        <OctalComponentPage
            title="Traefik"
            overview="Traefik (pronounced _traffic_) is a modern HTTP reverse proxy and load balancer that makes deploying microservices easy.
            Traefik integrates with your existing infrastructure components ([Docker](https://www.docker.com/), [Swarm mode](https://docs.docker.com/engine/swarm/), [Kubernetes](https://kubernetes.io), [Marathon](https://mesosphere.github.io/marathon/), [Consul](https://www.consul.io/), [Etcd](https://coreos.com/etcd/), [Rancher](https://rancher.com), [Amazon ECS](https://aws.amazon.com/ecs), ...) and configures itself automatically and dynamically.
            Pointing Traefik at your orchestrator should be the _only_ configuration step you need."
            module_name="terraform-kubernetes-traefik"
            module_license="Apache License 2.0"
            service_license="MIT License"
            details={{
                service_homepage: "https://traefik.io/",
                service_documentation: "https://doc.traefik.io/traefik/",
                module_repository: "https://github.com/project-octal/terraform-kubernetes-traefik",
                module_registry: "https://registry.terraform.io/modules/project-octal/traefik/kubernetes"
            }}
            related_modules={[
                {
                    "name": "terraform-octal-ingress-route",
                    "description": "Deploys a Traefik ingress route",
                    "documentation_link": "",
                    "github_link": "https://github.com/project-octal/terraform-traefik-ingress-route",
                    "module_repo_link": ""
                },
                {
                    "name": "terraform-kubernetes-oauth-endpoint",
                    "description": "Terraform module for creating a Traefik forward-auth endpoint. ",
                    "documentation_link": "",
                    "github_link": "https://github.com/project-octal/terraform-kubernetes-oauth-endpoint",
                    "module_repo_link": ""
                }
            ]}
            example_code={`
            module "traefik" {
                source  = "project-octal/traefik/kubernetes"
                version = "1.0.0"
              
                image_tag                            = "2.4.8"
                namespace                            = "kube-traefik"
                log_level                            = "INFO"
                replicas                             = 2
                rolling_update_max_surge             = 1
                rolling_update_max_unavailable       = 1
                pod_termination_grace_period_seconds = 1
                service_type                         = "LoadBalancer"
                preferred_node_selector              = []
                enable_dashboard                     = true
              }
            `}
        />
    );
}